<bb-render-html [path]="path$ | async"></bb-render-html>
